module.exports = "https://cdn.thelire.com/ins/resource/lh_more_vip_off.ac69d87c82e25d9f1ea7f6019f2c0377.png";